import { Button } from 'components/common'
import SearchBar from 'components/common/dataTable/searchBar'
import { PlusIcon } from 'components/icons'
import { ChainTable } from 'components/chainManagement'
import { usePageAccess } from 'hooks'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { PAGE_ADD_CHAIN } from 'utils/constants'

const ChainManagement = () => {
  const navigate = useNavigate()
  const { isEditor } = usePageAccess()

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Chain Management</title>
      </Helmet>

      {isEditor && (
        <Button
          buttonText="Create New Chain"
          icon={<PlusIcon />}
          className="mb-5"
          onClick={() => navigate(PAGE_ADD_CHAIN.path)}
        />
      )}

      <div
        className={`${
          isEditor ? 'mt-4' : ''
        } mb-2 flex flex-wrap items-center justify-between md:mb-0 md:flex-nowrap`}
      >
        <h3 className="title">Current Chains</h3>
        <SearchBar placeholder="Search by Chain Name and ID" />
      </div>

      <ChainTable isEditor={isEditor} />
    </>
  )
}

export default ChainManagement
